<div class="col-sm-12 my-3 my-md-5">
    <div class="col-sm-12">
        <h2>Plan Out</h2>
    </div>
    <mat-tab-group mat-align-tabs="start">
        <mat-tab label="Plan Sent">
            <div class="card">
                <mat-accordion class="example-headers-align" multi>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                        <mat-panel-title>
                            <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                        </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="row mb-2 mt-2">
                            <div class="col-sm-2 mt-2">
                                <input class="form-control" [(ngModel)]="plan_sent_search" type="text" placeholder="Search" />
                            </div>
                            <div class="col-sm-2 mt-2">
                                <mat-form-field appearance="fill">
                                    <mat-label>From & To Date For Plan Sent</mat-label>
                                    <mat-date-range-input [max]="maxDate" [rangePicker]="plan_sent_picker">
                                        <input matStartDate #planSentDateRangeStart placeholder="Start date">
                                        <input matEndDate #planSentDateRangeEnd placeholder="End date" (dateChange)="planSentDateRangeChange(planSentDateRangeStart, planSentDateRangeEnd)">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="plan_sent_picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #plan_sent_picker></mat-date-range-picker>
                                </mat-form-field>
                                <mat-icon (click)="planSentClearDate()">clear</mat-icon>
                            </div>
                            <div class="col-sm-2 mt-2">
                                <mat-form-field appearance="fill" >
                                    <mat-label>Approval Received Date</mat-label>
                                    <mat-date-range-input [rangePicker]="picker">
                                        <input matStartDate #dateRangeStart placeholder="Start date">
                                        <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #picker></mat-date-range-picker>
                                </mat-form-field>
                                <mat-icon (click)="clearDate()">clear</mat-icon>
                            </div>
                            <div class="col-sm-2 mt-2">
                                <mat-form-field appearance="fill">
                                    <mat-label>ODS Plan Received Date</mat-label>
                                    <mat-date-range-input [rangePicker]="ods_picker">
                                        <input matStartDate #odsplanSentDateRangeStart placeholder="Start date">
                                        <input matEndDate #odsplanSentDateRangeEnd placeholder="End date" (dateChange)="dateRangeChangeODS(odsplanSentDateRangeStart, odsplanSentDateRangeEnd)">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="ods_picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #ods_picker></mat-date-range-picker>
                                </mat-form-field>
                                <mat-icon (click)="clearDateODS()">clear</mat-icon>
                            </div>
                            <div class="col-sm-2 mt-2">
                                <mat-form-field appearance="fill">
                                    <mat-label>Snazzy Plan Received Date</mat-label>
                                    <mat-date-range-input [rangePicker]="snazzy_picker">
                                        <input matStartDate #snazzyplanSentDateRangeStart placeholder="Start date">
                                        <input matEndDate #snazzyplanSentDateRangeEnd placeholder="End date" (dateChange)="dateRangeChangeSnazzy(snazzyplanSentDateRangeStart, snazzyplanSentDateRangeEnd)">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="snazzy_picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #snazzy_picker></mat-date-range-picker>
                                </mat-form-field>
                                <mat-icon (click)="clearDateSnazzy()">clear</mat-icon>
                            </div>


                            <div class="col-sm-2 mt-2">
                                <mat-form-field appearance="fill">
                                    <mat-label>SOF Filled Date</mat-label>
                                    <mat-date-range-input [rangePicker]="sof_picker">
                                        <input matStartDate #sofDateRangeStart placeholder="Start date">
                                        <input matEndDate #sofDateRangeEnd placeholder="End date" (dateChange)="dateRangeChangeSOF(sofDateRangeStart, sofDateRangeEnd)">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="sof_picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #sof_picker></mat-date-range-picker>
                                </mat-form-field>
                                <mat-icon (click)="clearDateSOF()">clear</mat-icon>
                            </div>
                            <div class="col-sm-2 mt-2">
                                <mat-form-field appearance="fill">
                                    <mat-label>Send to Production Date</mat-label>
                                    <mat-date-range-input [rangePicker]="production_picker">
                                        <input matStartDate #productionDateRangeStart placeholder="Start date">
                                        <input matEndDate #productionDateRangeEnd placeholder="End date" (dateChange)="dateRangeChangeProduction(productionDateRangeStart, productionDateRangeEnd)">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="production_picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #production_picker></mat-date-range-picker>
                                </mat-form-field>
                                <mat-icon (click)="clearDateProduction()">clear</mat-icon>
                            </div>
                            <div class="col-sm-2 mt-2">
                                <mat-form-field appearance="fill">
                                    <mat-label>Aligner Received Date</mat-label>
                                    <mat-date-range-input [rangePicker]="ard_picker">
                                        <input matStartDate #ardDateRangeStart placeholder="Start date">
                                        <input matEndDate #ardDateRangeEnd placeholder="End date" (dateChange)="dateRangeChangeAlignerReceived(ardDateRangeStart, ardDateRangeEnd)">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="ard_picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #ard_picker></mat-date-range-picker>
                                </mat-form-field>
                                <mat-icon (click)="clearDateAlignerReceived()">clear</mat-icon>
                            </div>




                            <div class="col-sm-3 mt-2">
                                <button type="button" class="btn btn-primary ml-4 mb-4" [disabled]="plan_sent_loading" (click)="searchPlanSent(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Plan Sent</button>
                                <button type="button" class="btn btn-primary ml-2 mb-4" [disabled]="plan_sent_loading" (click)="resetPlanSentFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                                <button type="button" class="btn btn-success ml-2 mb-4" [disabled]="plan_sent_loading" (click)="exportPlanSentList()"  data-toggle="tooltip" data-placement="top" title="Export Plan Sent"><i class="fa fa-file-excel"></i></button>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
                
                <div class="col-sm-12">
                    <div class="container-fluid row">
                        <div class="col-sm-6 p-3">
                            <button type="button" class="btn btn-success" [disabled]="plan_sent_loading" (click)="searchPlanSent(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':plan_sent_loading}"></i> Refresh List</button>
                        </div>
                        <div class="col-sm-6 p-3"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
                    </div>
                    <div class="tableFixHead" style="overflow: scroll">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Circle</th>
                                    <th>Customer Name</th>
                                    <th>Glamyo Patient ID</th>
                                    <th>Mobile</th>
                                    <th>Pro Name</th>
                                    <th>Total Payment Received</th>
                                    <th>Snazzy Plan Received Date</th>
                                    <th>ODS Plan Received Date</th>
                                    <th>Plan Sent At</th>
                                    <th>Plan Approved</th>
                                    <th>Approval Received Date</th>
                                    <th>SOF Filled Date</th>
                                    <th>Sent to Production Date</th>
                                    <th>Total no of upper aligners</th>
                                    <th>Total no of Lower aligners</th>
                                    <th>Aligner received Date</th>
                                    <th>No of Upper Aligner Received</th>
                                    <th>No of Lower Aligner Received</th>
                                    <th>Remaining Upper Aligner</th>
                                    <th>Remaining Lower Aligner</th>
                                    <th>Dispatch Date</th>
                                    <th>Tracking ID</th>
                                    <th>Aligner Delivery Date</th>
                                    <th>Clinic Visit/VC Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let plans of planSentLists;let index = index;">
                                    <td >{{(pageIndex*perpage)+index+1}}</td>
                                    <td>{{plans.circle_name}}</td>
                                    <td>{{plans.lead_name}}</td>
                                    <td>{{plans.glamyo_patient_id}}</td>
                                    <td>{{plans.mobile}}</td>
                                    <td>{{plans.pro_name}}</td>
                                    <td>
                                        <span *ngIf="plans.payment_status != 1 ">-</span>
                                        <span *ngIf="plans.payment_status == 1 && (plans.totalAmt-plans.received_amt) > 0">No</span>
                                        <span *ngIf="plans.payment_status == 1 && (plans.totalAmt-plans.received_amt) <= 0">Yes</span>
                                    </td>
                                    <td><span *ngIf="plans.snazzy_plan_received_date">{{plans.snazzy_plan_received_date*1000|date:'d MMM, yyyy hh:mm aa'}}</span></td>
                                    <td><span *ngIf="plans.ods_plan_received_date">{{plans.ods_plan_received_date*1000|date:'d MMM, yyyy hh:mm aa'}}</span></td>
                                    <td><span *ngIf="plans.share_with_patient_on">{{plans.share_with_patient_on*1000|date:'d MMM, yyyy hh:mm aa'}}</span></td>
                                    <td><span *ngIf="plans.approval_received==1">Yes</span><span *ngIf="plans.approval_received!=1">No</span></td>
                                    <td><span *ngIf="plans.approval_received_date">{{plans.approval_received_date*1000|date:'d MMM, yyyy'}}</span></td>
                                    <td><span *ngIf="plans.sof_filled_date">{{plans.sof_filled_date*1000|date:'d MMM, yyyy'}}</span></td>
                                    <td><span *ngIf="plans.send_to_production_on">{{plans.send_to_production_on*1000|date:'d MMM, yyyy hh:mm aa'}}</span></td>
                                    <td>{{plans.upper_aligners}}</td>
                                    <td>{{plans.lower_aligners}}</td>
                                    <td><span *ngIf="plans.aligner_received_on">{{plans.aligner_received_on*1000|date:'d MMM, yyyy hh:mm aa'}}</span></td>
                                    <td>
                                        <span *ngIf="plans.upper_aligner_received">{{plans.upper_aligner_received}}</span>
                                        <span *ngIf="!plans.upper_aligner_received">0</span>
                                    </td>
                                    <td>
                                        <span *ngIf="plans.lower_aligner_received">{{plans.lower_aligner_received}}</span>
                                        <span *ngIf="!plans.lower_aligner_received">0</span>
                                    </td>
                                    <td>{{plans.upper_aligners - plans.upper_aligner_received}}</td>
                                    <td>{{plans.lower_aligners - plans.lower_aligner_received}}</td>
                                    <td><span *ngIf="plans.aligner_dispatched_date">{{plans.aligner_dispatched_date*1000|date:'d MMM, yyyy'}}</span></td>
                                    <td>{{plans.tracking_id}}</td>
                                    <td><span *ngIf="plans.aligner_delivery_date">{{plans.aligner_delivery_date*1000|date:'d MMM, yyyy'}}</span></td>
                                    <td><span *ngIf="plans.clinic_visit_required_on">{{plans.clinic_visit_required_on*1000|date:'d MMM, yyyy hh:mm aa'}}</span></td>
                                </tr>
                                <tr *ngIf="plan_sent_loading">
                                    <td colspan="23" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                                </tr>
                                <tr *ngIf="plan_sent_loaded && !planSentLists.length">
                                    <td colspan="23" class="text-center"><i class="far fa-frown"></i> Sorry! No Plan Sent Found</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
                </div>
            </div>
        </mat-tab>
        <!-- <mat-tab label="Pre-Plan Customers">
            <div class="card">
                <div class="col-sm-12">
                    <div class="form-group p-5 border-bottom">
                        <div class="row">
                            <div class="col-sm-3 mt-2">
                                <input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" />
                            </div>
                            <div class="col-sm-7 mt-2">
                                <mat-form-field appearance="fill">
                                    <mat-label>From & To Date For Preplan Customer</mat-label>
                                    <mat-date-range-input [rangePicker]="picker" [max]="maxDate">
                                        <input matStartDate #dateRangeStart placeholder="Start date">
                                        <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #picker></mat-date-range-picker>
                                </mat-form-field>
                                <mat-icon (click)="clearDate()">clear</mat-icon>
                                <button type="button" class="btn btn-primary ml-4 mb-4" [disabled]="preplan_loading" (click)="searchPreplanCustomer()"> <i class="fa fa-search" aria-hidden="true"></i> Search Preplan Customer</button>
                                <button type="button" class="btn btn-primary ml-2 mb-4" [disabled]="preplan_loading" (click)="resetPreplanCustomerFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                                <button type="button" class="btn btn-success ml-2 mb-4" [disabled]="preplan_loading" ><i class="fa fa-file-excel"></i> Export Preplan Customer</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 p-5">
                    <div class="tableFixHead" style="overflow: scroll">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Glamyo Patient ID</th>
                                    <th>Customer Name</th>
                                    <th>Circle</th>
                                    <th>Scan Pro</th>
                                    <th>Appointment Type</th>
                                    <th>Appointment Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr *ngIf="preplan_loading">
                                    <td colspan="7" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                                </tr>
                                <tr *ngIf="preplan_loaded">
                                    <td colspan="7" class="text-center"><i class="far fa-frown"></i> Sorry! No Preplan Customer Found</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </mat-tab> -->
    </mat-tab-group>
</div>